export * as Api from './api';

export enum AdminUserRealm {
  Super = 'SUPER',
  Eis = 'EIS',
  Lp = 'LP',
}
